@if (!isHidden()) {
    <div 
        class="container-menu-options" 
        animate.enter="slide-in-from-right"
        animate.leave="slide-out-to-right">

        <ia-item 
            [icon]="'edit-2'" 
            [text]="('document.edit.iaOptions.spellCheck' | translate)" 
            (click)="fixText.emit(); close.emit();"
        />
        
        @if (field().type !== DocumentItemTypeEnum.SUBTITLE) {
            <ia-item 
                [icon]="'magicpen'" 
                [text]="('document.edit.iaOptions.useAsPrompt' | translate)" 
                (click)="useAsPrompt.emit(); close.emit();"
            />
        }
        
        @if (field().type === DocumentItemTypeEnum.IMAGE || field().type === DocumentItemTypeEnum.GROUP_IMAGE) {
            <ia-item
                [icon]="'gallery'"
                [text]="('document.edit.iaOptions.autoDescription' | translate)"
                (click)="generateAutomaticDescription.emit(); close.emit();"
            />
        }

        <!-- Vídeo: a IA vê quadros do vídeo e ouve a fala. Vale também enquanto ele é
             otimizado, porque o arquivo original já toca. -->
        @if (field().type === DocumentItemTypeEnum.VIDEO || field().type === DocumentItemTypeEnum.GROUP_VIDEO) {
            <ia-item
                [icon]="'video-play'"
                [text]="('document.edit.iaOptions.autoDescription' | translate)"
                (click)="generateAutomaticDescription.emit(); close.emit();"
            />
        }

        @if (hasOriginalBackup()) {
            <ia-item
                [icon]="'rotate-right'"
                [text]="('document.edit.iaOptions.restoreOriginal' | translate)"
                (click)="restoreOriginalText.emit(); close.emit();"
            />
        }
    </div>
}
